import { useMemo } from 'react';
import useCurrentSystem from '../query/useCurrentSystem';
import { makeModeConstants } from '../../../actionCreators/mode';

export default function useCurrentSystemInfo(system_id: string | null) {
  const { data } = useCurrentSystem(system_id ?? '', { enabled: Boolean(system_id) });

  const currentSystemData = useMemo(() => data || {}, [data]);

  const modeInfo = useMemo(() => {
    if (!currentSystemData) return null;
    return makeModeConstants({
      type: currentSystemData?.hardware_type,
      type_name: currentSystemData?.hardware_type_name,
      type_name_plural: currentSystemData?.hardware_type_name_plural,
      hardware_type_gid: currentSystemData?.hardware_type_gid,
      configuration: currentSystemData?.configuration,
    });
  }, [currentSystemData]);

  return {
    ...currentSystemData,
    modeInfo: modeInfo,
  };
}
